/**
 * Builds Liberty / PMC / Charity / Renter role buckets from GET /roles config.
 * Mirrors Angular UserManagementAddRoleComponent Init() — user_roles store subscription.
 *
 * Charity Accounts → Charities section (ROLE_ATLANTA_OPEN_DOOR_ADMIN / _MANAGER etc.).
 * Angular deletes Charity + Liberty buckets when the logged-in user has a company or charity role.
 */
import {
  LIBERTY_ROLES,
  PROPERTY_ROLES,
  COMPANY_ROLES,
  CHARITY_ROLES,
} from '@/constants/roles'
import type { RoleCategory, AssignRoleProcessedRole } from '../types'

export type { AssignRoleProcessedRole }

export function buildFilteredRoles(
  roleData: Record<string, RoleCategory>,
  myRoleName: string,
): {
  liberty: AssignRoleProcessedRole[]
  pmc: AssignRoleProcessedRole[]
  charity: AssignRoleProcessedRole[]
  renter: AssignRoleProcessedRole[]
} {
  const liberty: AssignRoleProcessedRole[] = []
  const pmc: AssignRoleProcessedRole[] = []
  const charity: AssignRoleProcessedRole[] = []
  const renter: AssignRoleProcessedRole[] = []

  const isMeCompany = (COMPANY_ROLES as readonly string[]).includes(myRoleName)
  const isMeProperty = (PROPERTY_ROLES as readonly string[]).includes(myRoleName)
  const isMeCharity = (CHARITY_ROLES as readonly string[]).includes(myRoleName)
  const isMeLiberty = (LIBERTY_ROLES as readonly string[]).includes(myRoleName)

  Object.entries(roleData).forEach(([catKey, cat]) => {
    Object.entries(cat.roles).forEach(([roleKey, roleDef]) => {
      const entry: AssignRoleProcessedRole = {
        key: roleKey,
        name: roleDef.name,
        desc: roleDef.desc,
        roleType: catKey,
      }

      if (cat.name === 'Applicants') {
        if (isMeLiberty) renter.push(entry)
      } else if (cat.name === 'Liberty Accounts') {
        const blocked = ['ROLE_ADMIN', 'ROLE_LIBERTY_ACCOUNTING'].includes(roleKey)
        if (!blocked || myRoleName === 'ROLE_ADMIN') {
          liberty.push({ ...entry, roleType: 'LIBERTY' })
        }
      } else if (cat.name === 'Charity Accounts') {
        charity.push(entry)
      } else {
        if (catKey === 'PROPERTY') {
          pmc.push(entry)
        } else if (catKey === 'COMPANY' && !isMeProperty && myRoleName !== 'ROLE_REGIONAL_MANAGER') {
          pmc.push(entry)
        }
      }
    })
  })

  const deleteLibertyAndCharity = isMeCompany || isMeCharity

  return {
    liberty: deleteLibertyAndCharity ? [] : liberty,
    pmc,
    charity: deleteLibertyAndCharity ? [] : charity,
    renter,
  }
}
